<script setup lang="ts">
import { COURIER_MODES_ARRAY } from '@lib/zod/CourierSchemas';
import { ExternalLink } from 'lucide-vue-next';

const props = defineProps<{
    isLink: boolean,
    origin: String,
    destination: String,
    waypoints?: String[],
    travelMode?: (typeof COURIER_MODES_ARRAY)[number] | null,
}>();

function getMapUrl(
): string {
    return `https://www.google.com/maps/embed/v1/directions?` +
        `destination=${props.destination}` +
        `&origin=${props.origin}` +
        (props.waypoints ? `&waypoints=${props.waypoints.join('|')}` : '') +
        (props.travelMode ? `&mode=${props.travelMode.toLowerCase()}` : '') +
        `&key=${import.meta.env.PUBLIC_GMAPS_EMBED_API_KEY}`;
}

function getMapLink(): string {
    // https://developers.google.com/maps/documentation/urls/get-started
    return `https://www.google.com/maps/dir/?api=1&` +
        `destination=${props.destination}` +
        `&origin=${props.origin}` +
        (props.travelMode ? `&travelmode=${props.travelMode?.toLowerCase()}` : '') +
        (props.waypoints ? `&waypoints=${props.waypoints.join('|')}` : '');
}


</script>
<template>
    <div class="relative">
        <div class="overflow-hidden rounded-md w-full h-[50vh]">
            <!-- :style="{'pointer-events': isLink ? 'auto' : 'none', }" -->
            <!-- style="border:0;zoom: 1;transform: scale(1);transform-origin: center center;" -->
            <!-- style="transform: scale(2); zoom: 0.5;" -->
            <iframe width="100%"
                    height="100%"
                    class="rounded-md"
                    frameborder="0"
                    allow="accelerometer *; gyroscope *;"
                    referrerpolicy="no-referrer-when-downgrade"
                    allowfullscreen="false"
                    :src="getMapUrl()">
            </iframe>
            <!-- <div
                 class="absolute top-0 left-0 w-full h-[50vh] dark:backdrop-hue-rotate-180 dark:backdrop-invert rounded-md pointer-events-none">
            </div> -->
        </div>
        <a v-if="isLink"
           target="_blank"
           class="z-10 bg-background/80 p-4 min-w-full text-center"
           :href="getMapLink()">
            <ExternalLink class="mr-2 inline-block" /> Open in GoogleMaps
        </a>
    </div>
</template>